import React, { useContext, useState, useEffect } from 'react';
import { AppContext, DispatchContext } from "../AppContext";
import { makeStyles } from '@material-ui/core/styles';
import ShareIcon from "@material-ui/icons/Share";
import MenuIcon from '@material-ui/icons/Menu';
import ReplayIcon from '@material-ui/icons/Replay';
import DownloadIcon from "@material-ui/icons/CloudDownload";
import ClearIcon from "@material-ui/icons/Clear";
import Grid from "@material-ui/core/Grid";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import * as actions from '../actions/actions';
import { IconButton, Switch, FormControlLabel } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { config, timeConverter } from '../helpers/constants';
import AddIcon from '@material-ui/icons/Add';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import GroupIcon from '@material-ui/icons/Group';
import SettingsIcon from '@material-ui/icons/Settings';
import TimelineIcon from '@material-ui/icons/Timeline';

const useStyles = makeStyles({
  paCenterHeader: {
    display: "flex",
    height: '56px',
    backgroundColor: "#eeeeee",
    alignItems: "center",
    margin: "0",
    paddingLeft: 15,
    paddingRight: 15,
    zIndex: 5,
    boxShadow: "0px 0px 2px 2px rgba(0, 0, 0, 0.2)",
    position: "relative",
    flexWrap: "nowrap"
  },
  titleHead: {
    fontSize: "1.5rem",
    flex: "1 0 auto",
    minWidth: "fit-content",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    marginRight: 16,
  },
  filterField: {
    flex: "1 1",
    marginLeft: 5,
    marginRight: 5,
    minWidth: 90,
  },
  controls: {
    display: "flex",
    flex: "0 1 1000px",
    alignItems: "center",
  },
  iconButton: {
    marginLeft: 5,
    marginRight: 5,
  },
  resetFilterButton: {
    marginLeft: 0,
    marginRight: 15,
  },
  projectControls: {
    display: "flex",
    //flex: "0 1 350px",
    alignItems: "center",
  },
  percent_pos: {
    width: 330,
    height: 42,
    textAlign: "center",
    color: "#0D4A81",
    fontWeight: "400",
    fontSize: 30,
    textShadow: "1px 1px 3px #ffffff",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
});

export default function Title(props) {
  const dispatch = useContext(DispatchContext);
  const state = useContext(AppContext);
  const s = state.strings;
  const classes = useStyles(state);

  // local search phrase to prevent triggering update on changes, this will be handled via timeout 
  const [searchPhrase, setSearchPhrase] = useState(state.reportFilter.search);
  const [searchTimeoutId, setSearchTimeoutId] = useState(0);
  const [ownerPhrase, setOwnerPhrase] = useState(state.reportFilter.ownermail || "");
  const [ownerTimeoutId, setOwnerTimeoutId] = useState(0);

  const isAdmin = state.user && state.user.license && state.user.userId == state.user.license.adminUserId;

  // Capture external changes in report state and reflect it in the local var (required for search reset via state)
  useEffect(() => {
    if (props.type === "ProjectOverview") {
      setSearchPhrase(state.projectFilter.search);
    } else if (props.type === "ReportOverview") {
      setSearchPhrase(state.reportFilter.search);
    } else if (props.type === "LicenseAdmin") {
      setSearchPhrase(state.licenseAdmin.usersFilter.search);
    }
  }, [state.reportFilter.search, state.projectFilter.search, state.licenseAdmin.usersFilter.search]);

  useEffect(() => {
    setOwnerPhrase(state.reportFilter.ownermail || "");
  }, [state.reportFilter.ownermail]);


  const onCopied = () => {
    dispatch(actions.openToast({ type: "success", message: s.notificationMessage.reportLinkCopied, status: true }));
  }

  const handlePdfDownload = () => {
    dispatch(actions.openReportDownloadDialog([state.activeReport.PermaLinkId]));
  }

  const togglePropertyBar = () => {
    dispatch(actions.setUI({ propertyBarVisible: !state.ui.propertyBarVisible }))
  }


  const onApplyReportFilter = (filter) => {
    dispatch(actions.apply_report_filter(filter));
  }

  const onApplyProjectFilter = (filter) => {
    dispatch(actions.apply_project_filter(filter));
  }

  const onSearchChanged = (value) => {
    setSearchPhrase(value);
    clearTimeout(searchTimeoutId);
    if (props.type === "ProjectOverview") {
      setSearchTimeoutId(setTimeout(onApplyProjectFilter, 500, { search: value }));
    } else if (props.type === "ReportOverview") {
      setSearchTimeoutId(setTimeout(onApplyReportFilter, 500, { ...state.reportFilter, search: value }));
    } else if (props.onSearchChanged) {
      setSearchTimeoutId(setTimeout(props.onSearchChanged, 500, value));
    }
  }

  const onResetReportFilter = () => {
    dispatch(actions.clear_report_filter());
  }

  const onOwnerChanged = (e) => {
    setOwnerPhrase(e.target.value);
    clearTimeout(ownerTimeoutId);
    setOwnerTimeoutId(setTimeout(onApplyReportFilter, 500, { ...state.reportFilter, ownermail: e.target.value }));
  }

  const onIncludeLicenseReportsChanged = (e) => {
    const checked = e.target.checked;
    if (checked) {
      onApplyReportFilter({ ...state.reportFilter, includeLicenseReports: 1 });
    } else {
      setOwnerPhrase("");
      onApplyReportFilter({ ...state.reportFilter, includeLicenseReports: 0, ownermail: "" });
    }
  }

  const onResetLicenseAdminFilter = () => {
    dispatch(actions.setAdminLicense({ usersFilter: { date: null, search: "", license: "", current: null } }));
  }


  const onResetProjectFilter = () => {
    dispatch(actions.clear_project_filter());
  }

  const createProjectPopup = () => {
    dispatch(actions.create_project_popup(true));
  }

  const onNewPlagCheckClicked = () => {
    dispatch(actions.navigate_to("/plagiarism/new"))
  }

  const onNewTextComparisonClicked = () => {
    if (props.onCreateNew) {
      props.onCreateNew();
      return;
    }
    window.location.href = config.backendUrl + (state.lang === "de" ? "de/werkzeuge-hilfsmittel/neuertextvergleich" : "tools_utilities/newtextcompare");
  }

  const onReloadChecksClicked = () => {
    dispatch(actions.notifyReportsChanged());
  }

  const onLicenseViewChanged = (event, newView) => {
    if (newView != null) {
      dispatch(actions.setUI({ licenseView: newView }));
    }
  }

  let percentValue = state.activeReport.ResultPercent && parseInt(state.activeReport.ResultPercent) || 0;

  return (
    <div className={classes.paCenterHeader}>
      <div className={classes.titleHead} >
        {props.title}
      </div>
      {props.type == "ReportReview" ?
        <>
          <Grid>
            <CopyToClipboard text={`${config.frontendUrl + "permalink/" + state.activeReport.PermaLinkId}`} onCopy={onCopied}>
              <IconButton className={classes.iconButton}>
                <ShareIcon />
              </IconButton>
            </CopyToClipboard>
            <IconButton className={classes.iconButton} onClick={handlePdfDownload}>
              <DownloadIcon />
            </IconButton>
            {state.ui.propertyBarVisible &&
              <IconButton className={classes.iconButton} onClick={togglePropertyBar}>
                <MenuIcon />
              </IconButton>
            }
          </Grid>
          {!state.ui.propertyBarVisible && <>
            <div style={{ backgroundImage: `url(${config.backendUrl}button?percent=${percentValue}&size=3` }} className={classes.percent_pos} onClick={togglePropertyBar}>
              {state.activeReport.ResultPercent || 0}%
            </div>
            <IconButton className={classes.iconButton} onClick={togglePropertyBar}>
              <MenuIcon />
            </IconButton>
          </>

          }
        </>
        : ""
      }
      {props.type == "ReportOverview" ?
        <div className={classes.controls}>
          <TextField size="small"
            variant="outlined"
            label={s.search}
            className={classes.filterField}
            value={searchPhrase}
            onChange={(e) => onSearchChanged(e.target.value)}
          />
          <TextField className={classes.filterField}
            select
            label={s.project}
            variant="outlined"
            size="small"
            value={state.reportFilter.projectId}
            onChange={(evt) => onApplyReportFilter({ ...state.reportFilter, projectId: evt.target.value })}
          >
            <MenuItem value="">{s.filter.all}</MenuItem>
            {state.projects.map((proj) => (
              <MenuItem key={proj.Id} value={proj.Id}>{proj.Name}</MenuItem>
            ))}
          </TextField>
          <TextField className={classes.filterField}
            select
            label={s.date}
            variant="outlined"
            size="small"
            value={state.reportFilter.date}
            onChange={(evt) => onApplyReportFilter({ ...state.reportFilter, date: evt.target.value })}
          >
            <MenuItem key="report.date.all" value="">{s.filter.all}</MenuItem>
            <MenuItem key="report.date.today" value="1">{s.filter.today}</MenuItem>
            <MenuItem key="report.date.yesterday " value="2">{s.filter.yesterday}</MenuItem>
            <MenuItem key="report.date.last7" value="3">{s.filter.last7days}</MenuItem>
            <MenuItem key="report.date.last30" value="4">{s.filter.last30days}</MenuItem>
            <MenuItem key="report.date.thisMonth" value="5">{s.filter.thisMonth}</MenuItem>
            <MenuItem key="report.date.lastMonth" value="6">{s.filter.lastMonth}</MenuItem>
            <MenuItem key="report.date.thisYear " value="7">{s.filter.thisYear}</MenuItem>
            <MenuItem key="report.date.lastYear " value="8">{s.filter.lastYear}</MenuItem>

          </TextField>
          <TextField className={classes.filterField}
            select
            label={s.status}
            variant="outlined"
            size="small"
            value={state.reportFilter.state}
            onChange={(evt) => onApplyReportFilter({ ...state.reportFilter, state: evt.target.value })}
          ><MenuItem value="">{s.filter.all}</MenuItem>
            <MenuItem value="1">{s.filter.ok}</MenuItem>
            <MenuItem value="2">{s.filter.active}</MenuItem>
            <MenuItem value="3">{s.filter.error}</MenuItem>
            <MenuItem value="4">{s.filter.scheduled}</MenuItem>
            <MenuItem value="5">{s.filter.paused}</MenuItem></TextField>
          {isAdmin && state.user.license.allowViewLicenseReports && state.reportFilter.includeLicenseReports === 1 &&
            <TextField size="small"
              variant="outlined"
              label={s.common.owner}
              className={classes.filterField}
              value={ownerPhrase}
              onChange={onOwnerChanged}
            />}
          {isAdmin && state.user.license.allowViewLicenseReports &&
            <FormControlLabel
              style={{ marginLeft: 10 }}
              control={<Switch checked={state.reportFilter.includeLicenseReports === 1} onChange={onIncludeLicenseReportsChanged} />}
              label={s.reportOverview.licenseReports}
            />}
          <IconButton data-for="globalTT" data-tip={s.reportOverview.resetFilterTip} size="small" className={`${classes.iconButton}`} onClick={() => { onResetReportFilter(); }}>
            <ClearIcon />
          </IconButton>
          <IconButton data-for="globalTT" data-tip={s.reportOverview.reloadTip} size="small" className={classes.iconButton} onClick={() => { onReloadChecksClicked(); }}>
            <ReplayIcon />
          </IconButton>
          <IconButton data-for="globalTT" data-tip={s.reportOverview.newCheckTip} size="small" className={classes.iconButton} onClick={() => { onNewPlagCheckClicked(); }}>
            <AddIcon />
          </IconButton>
          <IconButton data-for="globalTT" data-tip={s.reportOverview.toggleDetailsTip} size="small" className={classes.iconButton} onClick={togglePropertyBar}>
            <MenuIcon />
          </IconButton>

          {/* <IconButton onClick={() => dispatch(actions.handle_performace_check(state.performCheckLayout === 'grid' ? 'list' : 'grid'))} >
            {state.performCheckLayout === 'list' ? <ViewComfyIcon /> : <ReorderIcon />}
          </IconButton> */}
        </div>
        : ""
      }
      {props.type == "ProjectOverview" ?
        <div className={classes.projectControls}>
          <TextField size="small"
            variant="outlined"
            label={s.search}
            className={classes.filterField}
            value={searchPhrase}
            onChange={(e) => onSearchChanged(e.target.value)}
          />
          <IconButton className={classes.iconButton} onClick={() => { onResetProjectFilter(); }}>
            <ClearIcon />
          </IconButton>
          <IconButton className={classes.iconButton} onClick={() => { createProjectPopup(); }}>
            <AddIcon />
          </IconButton>
        </div>
        : ""
      }
      {props.type == "LicenseAdmin" &&
        <div className={classes.projectControls}>
          <TextField size="small"
            variant="outlined"
            label={s.search}
            className={classes.filterField}
            value={searchPhrase}
            onChange={(e) => onSearchChanged(e.target.value)}
          />
          <TextField className={classes.filterField}
            select
            label={s.date}
            variant="outlined"
            size="small"
            value={state.licenseAdmin.usersFilter.date}
            onChange={(e) => { dispatch(actions.setAdminLicense({ usersFilter: { ...state.licenseAdmin.usersFilter, date: e.target.value } })) }}
          >
            <MenuItem value="">{s.filter.all}</MenuItem>
            <MenuItem value="1">{s.filter.today}</MenuItem>
            <MenuItem value="2">{s.filter.yesterday}</MenuItem>
            <MenuItem value="3">{s.filter.last7days}</MenuItem>
            <MenuItem value="4">{s.filter.last30days}</MenuItem>
            <MenuItem value="5">{s.filter.thisMonth}</MenuItem>
            <MenuItem value="6">{s.filter.lastMonth}</MenuItem>
            <MenuItem value="7">{s.filter.thisYear}</MenuItem>
            <MenuItem value="8">{s.filter.lastYear}</MenuItem>
            {state.licenseAdmin.phases.slice(0, 3).map((phase) => {
              return (
                <MenuItem value={100 + phase.phase}>
                  {s.filter.licensePhase.format(phase.phase, timeConverter(phase.validFrom, true, s.common.dateFormat), timeConverter(phase.validTo, true, s.common.dateFormat))}
                </MenuItem>
              );
            })}

          </TextField>

          <FormControlLabel
            style={{ marginLeft: 5, marginRight: 5, whiteSpace: "nowrap" }}
            control={<Switch
              checked={state.licenseAdmin.usersFilter.current === "1"}
              onChange={(e) => dispatch(actions.setAdminLicense({ usersFilter: { ...state.licenseAdmin.usersFilter, current: e.target.checked ? "1" : null } }))}
            />}
            label={s.filter.activeUsersOnly}
          />

          <IconButton className={classes.resetFilterButton} onClick={() => { onResetLicenseAdminFilter(); }}>
            <ClearIcon />
          </IconButton>
          {state.licenseAdmin.currentLicense &&
            <ToggleButtonGroup
              value={state.ui.licenseView}
              exclusive
              onChange={onLicenseViewChanged}
              size="small"

            >
              <ToggleButton value="usage">
                <GroupIcon />
              </ToggleButton>
              {state.licenseAdmin.currentLicense && !state.licenseAdmin.currentLicense.isChild && 
              <ToggleButton value="settings">
                <SettingsIcon />
              </ToggleButton>}
              <ToggleButton value="message">
                <ChatBubbleOutlineIcon />
              </ToggleButton>
              <ToggleButton value="statistics">
                <TimelineIcon />
              </ToggleButton>
            </ToggleButtonGroup>
          }
        </div>
      }

      {props.type == "TextComparisons" ?
        <IconButton data-for="globalTT" data-tip={s.textComparisons.newTip} size="small" className={classes.iconButton} onClick={onNewTextComparisonClicked}>
          <AddIcon />
        </IconButton>
        : ""
      }
    </div>

  )
}